







































































































































































import { Vue, Component } from 'vue-property-decorator';
import Header from 'components/header.vue';
import {
    getUserInfo, changePsd, changeCompany, changeContact, uploadCompanyLicense, deleteCompanyLicense, checkOldPwd,
} from '@/api/user';
import { clearObj } from '@/utils/formate';
@Component({
    components: { Header },
})
export default class UserInfo extends Vue {
    validatePass = (rule, value, callback) => {
        if (value === '') {
            callback(new Error('请重新输入'));
        } else {
            if (this.formValidate.judge_pwd && this.formValidate.judge_pwd !== '' && value !== this.formValidate.judge_pwd) {
                // 对第二个密码框单独验证
                callback(new Error('两次输入密码不一致'));
            }
            callback();
        }
    };

    validatePassCheck = (rule, value, callback) => {
        if (value === '') {
            callback(new Error('请重新输入'));
        } else if (value !== this.formValidate.new_pwd) {
            callback(new Error('两次输入密码不一致'));
        } else {
            callback();
        }
    };

    // 联系QQ 检测
    checkQQ = (rule:any, value:any, callback:any) => {
        if (value === '') {
            callback();
        } else {
            const reg = /^[1-9][0-9]{5,15}$/gi;
            const test = reg.test(value);
            if (!test) {
                callback(new Error('QQ输入有误'));
            } else {
                callback();
            }
        }
    }

    private editInfo :boolean = false;

    private user: any = {};

    private formValidate:any = { judge_pwd: '', new_pwd: '' }

    private Old:any = { password: '' }

    private ruleValide:any = {
        new_pwd: [
            { pattern: '(?![0-9]*$)(?![a-z A-Z]*$)[a-z A-Z 0-9 @#$%^&+=,. _!]{6,}', message: '请输入超过6位的由字母和数字组合的密码', trigger: 'blur' },
            { validator: this.validatePass, trigger: 'blur' },
        ],
        judge_pwd: [
            { validator: this.validatePassCheck, trigger: 'blur' },
        ],
    }

    private contactValide:any = {
        contact: [
            { trigger: 'blur', max: 50, message: '长度不能超过50个字符' },
        ],
        contact_qq: [
            { validator: this.checkQQ, trigger: 'blur' },
        ],
        contact_phone: [
            { trigger: 'blur', max: 11, message: '长度不能超过11位' },
            { validator: this.checkTel, trigger: 'blur' },
        ],
    }

    private companyValide:any = {
        company: [{ trigger: 'blur', max: 50, message: '长度不能超过50个字符' }],
        company_url: [
            { pattern: '^[^\u4e00-\u9fa5]{0,}$', message: '网址输入有误', trigger: 'blur' },
            { max: 100, message: '不能超过100个字符', trigger: 'blur' },
        ],
    }

    private picList: Array<any> = [];

    private eidtCompany: boolean = false;

    private compayValide:any = { company: '', company_url: '' };

    private editContact: boolean = false;

    private contactValidate:any = { contact_qq: '', contact_phone: '', contact: '' };

    private privateThis:any = this;

    private currentPic: any = {};

    private tip:boolean = false;

    private backendMsg: string = '';

    private licence: boolean = false;

    private canChangePwd:boolean = true;

    //  获取当前用户的信息
    getUser() {
        getUserInfo().then((res) => {
            if (res.data.status === 1) {
                this.user = res.data.data;
                this.picList = res.data.data.company_license;
            } else {
                this.privateThis.$Gtmessage.error(res.data.error_msg);
            }
        });
    }

    /**
     * EditInfo - 编辑账户信息
     */
    EditInfo() {
        if (this.editInfo && !this.canChangePwd) {
            (this.$refs.formValidate as any).validate((resp) => {
                if (resp) {
                    changePsd(this.formValidate).then((res) => {
                        if (res.data.status === 1) {
                            this.editInfo = false;
                            this.privateThis.$Gtmessage.success(res.data.error_msg);
                            this.canChangePwd = true;
                            this.Old.password = '';
                            clearObj(this.formValidate);
                        } else {
                            this.privateThis.$Gtmessage.error(res.data.error_msg);
                        }
                    });
                }
            });
        } else {
            this.editInfo = !this.editInfo;
        }
    }

    //  保存企业信息
    editCompanyInfo() {
        if (this.eidtCompany) {
            (this.$refs.compayValide as any).validate((resp) => {
                if (resp) {
                    changeCompany(this.compayValide).then((res) => {
                        if (res.data.status === 1) {
                            this.eidtCompany = false;
                            this.getUser();
                            this.privateThis.$Gtmessage.success(res.data.error_msg);
                            clearObj(this.privateThis);
                        } else {
                            this.privateThis.$Gtmessage.error(res.data.error_msg);
                        }
                    });
                }
            });
        } else {
            this.initEditData(this.compayValide);
            this.eidtCompany = !this.eidtCompany;
        }
    }

    // 保存联系人信息
    contactEdit() {
        if (this.editContact) {
            (this.$refs.contactValidate as any).validate((resp) => {
                if (resp) {
                    changeContact(this.contactValidate).then((res) => {
                        if (res.data.status === 1) {
                            this.editContact = false;
                            this.getUser();
                            this.privateThis.$Gtmessage.success(res.data.error_msg);
                            clearObj(this.contactValidate);
                        } else {
                            this.privateThis.$Gtmessage.error(res.data.error_msg);
                        }
                    });
                }
            });
        } else {
            this.initEditData(this.contactValidate);
            this.editContact = !this.editContact;
        }
    }


    // 联系人手机号检测
    checkTel(rule:any, value:any, callback:any) {
        if (this.contactValidate.contact_phone === '') {
            callback();
        } else {
            const reg = /^1[0-9]{10}$/gi;
            const tel = reg.test(this.contactValidate.contact_phone);
            if (!tel) {
                callback(new Error('手机号输入有误'));
            } else {
                callback();
            }
        }
    }

    initEditData(data:any) {
        Object.keys(data).forEach((d:any) => {
            data[d] = this.user[d];
        });
    }

    //  上传营业执照
    selectedFileOnChanged(e: any) {
        const file = e.target.files[0];
        const size = Math.floor(file.size / 1024);
        const left_length = 10 - Number(this.picList.length);
        if (size > 1024) {
            this.privateThis.$Gtmessage.error('不能超过1M');
            return;
        }
        const formData = new FormData();
        let i;
        if (left_length && left_length < 0) {
            this.privateThis.$Gtmessage.error('不能超过10张');
            return;
        }
        formData.append('company_license', file);
        uploadCompanyLicense(formData).then((res) => {
            if (res.data.status === 1) {
                this.picList = this.picList.concat(res.data.data);
            } else {
                this.privateThis.$Gtmessage.error(res.data.error_msg);
            }
        });

        // 上传交互后 将value制为空
        e.target.value = '';
    }

    //  删除 营业执照
    deletePic(img:any, index:any) {
        this.tip = true;
        this.currentPic = img;
        this.currentPic.index = index;
    }

    // 查看大图
    checkBigPic(img:any) {
        this.currentPic = img;
        this.licence = true;
    }

    //  弹出框确认删除
    deleteLic() {
        if (this.currentPic) {
            deleteCompanyLicense({ path: this.currentPic.path }).then((res:any) => {
                if (res.data.status === 1) {
                    this.picList.splice(this.currentPic.index, 1);
                    this.tip = false;
                } else {
                    this.backendMsg = res.data.error_msg;
                }
            });
        }
    }

    // 检测旧密码
    testOldPwd(pwd:any) {
        if (pwd && pwd !== '') {
            checkOldPwd({ password: pwd }).then((res) => {
                if (res.data.status === 1) {
                    this.canChangePwd = false;
                } else {
                    this.privateThis.$Gtmessage.error(res.data.error_msg);
                }
            });
        }
    }

    created() {
        this.getUser();
    }
}

